const initialState = {
  data: [],
  loading: false,
  success: false,
  error: false,
};

export const reportCommentCreate = () => (state = initialState, action) => {
  switch (action.type) {
    case `REPORT_COMMENT_CREATE_REQUEST`: {
      return { ...initialState, loading: true };
    }
    case `REPORT_COMMENT_CREATE_SUCCESS`: {
      return { ...state, data: action.data, loading: false, success: true };
    }
    case `REPORT_COMMENT_CREATE_FAILURE`: {
      return { ...state, data: action.error, loading: false, success: false, error: true };
    }
    default:
      return state;
  }
};
